import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { z } from 'zod';
import { ErroApi } from '../api/cliente';
import { auth } from '../api/endpoints';
import { Aviso } from '../components/Aviso';
import { Botao } from '../components/Botao';
import { Campo } from '../components/Campo';
import { useAtualizarSessao, useSessao } from '../hooks/useSessao';

const esquema = z.object({
  login: z.string().trim().min(1, 'Informe o login.'),
  senha: z.string().min(1, 'Informe a senha.'),
});
type Dados = z.infer<typeof esquema>;

export function Login() {
  const { data: sessao } = useSessao();
  const atualizarSessao = useAtualizarSessao();
  const navegar = useNavigate();
  const local = useLocation();
  const [erro, setErro] = useState<string | null>(null);
  const { register, handleSubmit, formState } = useForm<Dados>({ resolver: zodResolver(esquema) });

  if (sessao) return <Navigate to="/" replace />;

  async function entrar({ login, senha }: Dados) {
    setErro(null);
    try {
      const nova = await auth.entrar(login, senha);
      atualizarSessao(nova);
      const destino = (local.state as { de?: string } | null)?.de ?? '/';
      navegar(nova.usuario.deveTrocarSenha ? '/trocar-senha' : destino, { replace: true });
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não foi possível entrar. Tente de novo.');
    }
  }

  return (
    <main className="flex min-h-dvh items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <span aria-hidden className="h-10 w-1.5 rounded-sm bg-marca" />
          <div>
            <h1 className="text-xl leading-7 font-semibold">Precificador comercial</h1>
            <p className="text-tinta-2">Biopol Embalagens</p>
          </div>
        </div>

        <form onSubmit={handleSubmit(entrar)} noValidate className="flex flex-col gap-4 rounded-painel border border-linha bg-superficie p-6">
          {erro && <Aviso tipo="erro">{erro}</Aviso>}
          <Campo rotulo="Login" autoComplete="username" autoFocus erro={formState.errors.login?.message} {...register('login')} />
          <Campo rotulo="Senha" type="password" autoComplete="current-password" erro={formState.errors.senha?.message} {...register('senha')} />
          <Botao type="submit" variante="principal" carregando={formState.isSubmitting} className="mt-1 w-full">
            Entrar
          </Botao>
        </form>
        <p className="mt-4 text-center text-[13px] text-tinta-2">Esqueceu a senha? Peça ao administrador para redefinir.</p>
      </div>
    </main>
  );
}
